<template>
    <select :id="id" :name="name" class="form-control" :class="{'border-danger':error === true}"
            v-model="selected" :disabled="!isEditable" @change="triggerEvent">
        <option v-for="library in libraries" :value="library.id">{{library.name}}</option>
    </select>
</template>

<script>
import {EventBus} from "../mixins/event-bus";
import Cookies from "../mixins/cookies";

export default {
    name: "libraries-chooser",
    mixins: [Cookies],
    props: {
        id: {
            type: String,
            default: 'libraries'
        },
        name: {
            type: String,
            default: 'libraries'
        },
        libraries: {
            type: Array,
            required: true
        },
        defaultLibrary: {
            type: Number,
            required: true
        },
        error: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function () {
        return {
            selected: 0
        }
    },
    methods: {
        triggerEvent: function () {
            EventBus.$emit('libraryChangeEvent', {library_id: this.selected});
        }
    },
    computed: {
        isEditable: function () {
            return this.libraries.length > 1;
        }
    },
    mounted() {
        this.selected = this.defaultLibrary;
    }
}
</script>
